module.exports = __webpack_public_path__ + "static/img/nav1.0cfb4b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav1.jpg
// module id = 6oZp
// module chunks = 31